export function queryString (search) {
  const query = {}
  if (search) {
    const params = search.substring(1).split('&')
    params.forEach(item => {
      const kv = item.split('=')
      if (kv[1]) {
        query[kv[0]] = decodeURIComponent(kv[1])
      }
    })
  }
  return query
}

export function webpTest (cb) {
  if (localStorage.getItem('webp') === 'support') {
    cb(true)
  } else {
    const img = new Image()
    img.onload = () => {
      if (img.height > 0 && img.width > 0) {
        cb(true)
        localStorage.setItem('webp', 'support')
      }
    }
    img.onerror = () => {
      cb(false)
    }
    img.src = 'data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoCAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA=='
  }
}

export function visibilityChange (cb) {
  document.addEventListener('visibilitychange', () => {
    cb(document.hidden)
  }, false)
}

export function shuffle (array) {
  let m = array.length
  while (m) {
    const i = Math.floor(Math.random() * m--)
    const t = array[m]
    array[m] = array[i]
    array[i] = t
  }
  return array
}

export default {
  queryString,
  shuffle,
  webpTest,
  visibilityChange
}



// WEBPACK FOOTER //
// ./src/utils.js